import { render, staticRenderFns } from "./FreebieCounter.vue?vue&type=template&id=66674166&scoped=true&"
import script from "./FreebieCounter.vue?vue&type=script&lang=js&"
export * from "./FreebieCounter.vue?vue&type=script&lang=js&"
import style0 from "./FreebieCounter.vue?vue&type=style&index=0&id=66674166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66674166",
  null
  
)

export default component.exports